import request, { RequestConfig } from '@/libs/request'

/** 示例登录，约束传入参数 */
export const login = (data: { account: string; pswd: string }) => request<string>({ url: '/adminapi/Admin/login', data, method: 'GET' })

/** 示例获取登录者信息，灵活定义更多配置 */
export const getAdminInfo = (config: RequestConfig = {}) => request<string>({ url: '/adminapi/Admin/getAdminInfo', ...config })
